import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { BOM_USERS_API } from "../apiRoutes";

const mutateDeleteBomUser = async ({ id }: { id: string }) => {
  return await axiosAuth.delete(`${BOM_USERS_API}/${id}`);
};

const useDeleteBomUserMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteBomUser,
    ...queryParams,
  });

export default useDeleteBomUserMutation;
